export default __webpack_public_path__ + "static/Airgap_white-22afa481e01506c35130bc11b6fc366c.svg";